import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';


import MainLayout from '../../layouts/Main';
import TopApplicants from '../../sub_components/job_portals/TopApplicants';
import JobPosts from '../../sub_components/job_portals/JobPosts';
import { SVGIcon } from '../../wrappers/SVGIcon';

import { JobPortalTab, JobPostStatus } from '../../../interfaces/job_posts';

import { Icons } from '../../../data/Assets';

const JobPortalPage = () => {
    const navigate = useNavigate();

    const tabsList: JobPortalTab[] = [JobPortalTab.ACTIVE_JOBS, JobPortalTab.DRAFTS, JobPortalTab.ARCHIVED_JOBS, JobPortalTab.TOP_APPLICANTS];

    const [currentTab, setCurrentTab] = useState<JobPortalTab>(tabsList[0]);

    const renderTabContent = () => {
        switch (currentTab) {
            case JobPortalTab.ACTIVE_JOBS:
                return <JobPosts jobPostStatus={JobPostStatus.ACTIVE} setCurrentTab={setCurrentTab} />;
            case JobPortalTab.DRAFTS:
                return <JobPosts jobPostStatus={JobPostStatus.DRAFT} setCurrentTab={setCurrentTab} />;
            case JobPortalTab.ARCHIVED_JOBS:
                return <JobPosts jobPostStatus={JobPostStatus.ARCHIVED} setCurrentTab={setCurrentTab} />;
            case JobPortalTab.TOP_APPLICANTS:
                return <TopApplicants />;
        }
    }

    return (
        <MainLayout>
            <div className="immployer__common_details__layout">
                <div className="immployer__form_details__head">
                    <h2 className="color_dark">Job Manager</h2>

                    <div className="immployer__form_details__head__actions">
                        <button
                            className="immployer__btn immployer__btn__primary"
                            onClick={() => navigate('/job-portal/new')}
                        >
                            <SVGIcon src={Icons.Plus} color={'white'} />
                            Add Job
                        </button>
                        <button className="immployer__btn immployer__btn__secondary immployer__btn__secondary__disabled">
                            <SVGIcon src={Icons.Upload} color={'grey'} />
                            Upload
                        </button>
                    </div>
                </div>
                <div className="immployer__common_details__tabs__container">
                    <div className="immployer__tabs">
                        {tabsList.map((tab, index) =>
                            <button
                                key={index}
                                className={`immployer__tab ${currentTab === tab ? "immployer__tab__active" : ""}`}
                                onClick={() => setCurrentTab(tab)}
                            >
                                {tab}
                            </button>
                        )}
                    </div>
                </div>
                <div className="immployer__common_details__content">
                    {renderTabContent()}
                </div>
            </div>
        </MainLayout>
    )
}

export default JobPortalPage;